import { IInputValue } from "./templates";

/**
 * Define ServiceStatus interface
 */
export enum SERVICE_STATUS {
  DRAFT = 1,
  PAYMENT_ON_HOLD = 2,
  PAID = 3,
}

/**
 * Define ServiceType interface
 */
export enum SERVICE_TYPE {
  TEMPLATE = 1,
}

/**
 * Define ServiceData interface
 */
export interface IServiceData {
  name: string
  inputValues: IInputValue[]
  template_id: string
  first_download?: boolean,
  finished_document?: boolean,
  price?: number,
  watermark?: boolean
}

/**
 * Define PeopleData interface
 */
/* export interface IPeopleData {
  email: string
  uid: string
  editable: boolean
} */

/**
 * Define Service interface
 */
export interface IService {
  id: string
  user_id: string
  payment_id?: number
  service_status_id: number
  service_data?: IServiceData
  share_to?: any[]
  templates_id: string
  created_at: Date
  updated_at: Date
}